import React, { FC } from 'react';
import { twMerge } from 'tailwind-merge';

import Typography from '@/components/typography';

type Props = {
  className?: string;
  isVertical?: boolean;
  text?: string;
};

/** Divider UI Kit */
const Divider: FC<Props> = ({
  className = '',
  isVertical = false,
  text = null,
}) => (
  <div
    className={twMerge(
      'text-nowrap flex w-full items-center',
      isVertical && 'h-full w-[1px]',
      text && className
    )}
  >
    <div
      className={twMerge(
        isVertical ? 'h-full w-[1px]' : 'h-[1px] flex-1',
        'bg-gray-20',
        !text && className
      )}
    />
    {text && (
      <>
        <Typography
          className="text-nowrap flex-2 px-4 text-gray-60 "
          variant="button2"
        >
          {text}
        </Typography>
        <div
          className={twMerge(
            isVertical ? 'h-full w-[1px]' : 'h-[1px] flex-1',
            'bg-gray-20'
          )}
        />
      </>
    )}
  </div>
);

export default Divider;
